export interface VimeoVideoPicture {
  link: string;
}

export interface VimeoVideoPictures {
  sizes: VimeoVideoPicture[];
}

export interface VimeoVideoTag {
  uri: string;
  name: string;
  tag: string;
  canonical: string;
  resource_key?: string;
}

export enum VimeoVideoKeys {
  uri = 'uri',
  name = 'name',
  description = 'description',
  pictures = 'pictures',
  tags = 'tags',
}

export interface VimeoVideo {
  [VimeoVideoKeys.uri]: string;
  [VimeoVideoKeys.name]: string;
  [VimeoVideoKeys.description]?: string;
  [VimeoVideoKeys.pictures]?: VimeoVideoPictures;
  [VimeoVideoKeys.tags]?: VimeoVideoTag[];
}
